interface MessagingServiceManager {
  subscribe: (
    filter: { matcher: string; criteria: unknown },
    messageHandler: (event: unknown) => void,
    contextName?: string,
    id?: string,
  ) => unknown;
  unsubscribe: (subscriptionId: unknown, ...args: unknown[]) => void;
}

export type { MessagingServiceManager };

interface DataApiUtils {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getData: (dataPageName: string, params: Record<string, unknown>, contextName: string) => Promise<any>;
}

interface PCoreWindow {
  getMessagingServiceManager?: () => MessagingServiceManager;
  getStore?: () => { getState?: () => unknown };
  getDataApiUtils?: () => DataApiUtils;
  getStoreValue?: (storeName: string, propertyPath: string, contextName: string) => unknown;
}

function getPCore(): PCoreWindow | undefined {
  if (typeof window === 'undefined') return undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (window as any).PCore as PCoreWindow | undefined;
}

export default getPCore;
